<template>
  <li @click="toggleSidebar">
    <router-link :to="link" class="menu-item" :class="{ active: isActiveLink }">
      <img :src="`/icons/${linkIcon}.svg`" alt="Link Icon">
      <span v-if="!isCollapsed">{{ linkText }}</span>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    link: {
      type: Object,
      required: true
    },
    linkText: {
      type: String,
      required: true
    },
    linkIcon: {
      type: String,
      required: true
    },
    isCollapsed: {
      type: Boolean,
      required: true,
    }
  },
  methods: {
    toggleSidebar() {
      this.$emit('toggleSidebar')
    }
  },
  computed: {
    isActiveLink() {
      return this.$route.name === this.link.name
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
  padding: 0.8125rem 1rem;

  display: flex;
  align-items: center;
  gap: 1rem;

  text-decoration: none;
  color: white;
  font-weight: 600;

  img {
    min-width: 1.375rem;
    width: 1.375rem;
  }

  span {
    font-size: 0.875rem;
  }

  &.active,
  &:hover {
    background: #4D68B0;
    border: 0;
    border-radius: 6px;
  }
}
</style>
